import React from 'react';
import './Spinner.css';

const Spinner: React.FC<{ message?: string }> = ({ message = 'Carregando...' }) => {
  return (
    <div className="spinner-overlay">
      <div className="spinner-box">
        <div className="spinner" aria-hidden="true"></div>
        {message ? <div className="spinner-message">{message}</div> : null}
      </div>
    </div>
  );
};

export default Spinner;
